var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndDateCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3384_2910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.41413 9.92592C7.90593 9.92592 9.92592 7.90593 9.92592 5.41413C9.92592 2.92234 7.90593 0.902344 5.41413 0.902344C2.92234 0.902344 0.902344 2.92234 0.902344 5.41413C0.902344 7.90593 2.92234 9.92592 5.41413 9.92592Z",
    stroke: "#004643",
    strokeWidth: 1.08283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41418 7.21881L7.2189 5.41409L5.41418 3.60938",
    stroke: "#004643",
    strokeWidth: 1.08283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60938 5.41406H7.21881",
    stroke: "#004643",
    strokeWidth: 1.08283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3384_2910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8283,
    height: 10.8283,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndDateCalendar);
export default __webpack_public_path__ + "static/media/endDateCalendar.504ece696d7de22c1524ebc033a7f3e6.svg";
export { ForwardRef as ReactComponent };